import React from 'react';
import { getCardImageUrl } from '../utils/imageCache';

const CardDisplay = ({ card, onClick }) => {
  // Get the best image URL for the card using our helper function
  const imageSrc = getCardImageUrl(card);
  const isBattlefield = card?.type === 'Battlefield';

  return (
    <button
      type="button"
      aria-label={`Inspect ${card?.name || 'card'}`}
      className="w-full text-left bg-card/50 backdrop-blur-sm border border-border/50 rounded-xl overflow-hidden cursor-pointer hover:border-primary/50 transition-all hover:-translate-y-1 group"
      onClick={() => onClick(card)}
    >
      <div className="aspect-[2/3] w-full bg-muted/20 flex items-center justify-center overflow-hidden">
        {imageSrc ? (
          <div className={`${isBattlefield ? 'w-[140%] h-[140%]' : 'w-full h-full'}`}>
            <img
              src={imageSrc}
              alt={card?.name || 'Card'}
              className={`w-full h-full object-cover ${isBattlefield ? '-rotate-90' : ''}`}
              style={{
                objectFit: isBattlefield ? 'contain' : 'cover'
              }}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src = "/cards/placeholder.jpg"; // Fallback to placeholder
              }}
            />
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground">
            No Image
          </div>
        )}
      </div>
      <div className="p-4">
        <h4 className="font-bold truncate">{card?.name || 'Unknown Card'}</h4>
        <div className="flex justify-between items-center mt-2">
          <span className="text-sm px-2 py-1 bg-primary/10 text-primary rounded">
            {(Array.isArray(card?.types) && card.types.length ? card.types : [card?.type || 'Unknown']).join(' / ')}
          </span>
          <span className="text-sm text-muted-foreground">Energy: {card?.energy ?? 'N/A'}</span>
        </div>
        {card?.domains && Array.isArray(card?.domains) && card.domains.length > 0 && (
          <div className="flex gap-1 mt-2">
            {card.domains.map((domain, index) => (
              <img
                key={index}
                src={`https://cdn.piltoverarchive.com/colors/${domain}.webp?width=32`}
                alt={domain}
                className="w-4 h-4 rounded-full border border-border"
                loading="lazy"
                fetchPriority="low"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            ))}
          </div>
        )}
        {card?.rarity && (
          <div className="mt-2 text-xs text-muted-foreground">
            {card.rarity}
          </div>
        )}
      </div>
    </button>
  );
};

export default CardDisplay;
